import { gql } from '@apollo/client';
export const ADD_YARD = gql `
  mutation AddYard($data: CreateYardInput!) {
    addYard(data: $data) {
      id
      createdAt
      updatedAt
      nameExternal
      nameInternal
      marketId
      vendor
      address
      spots
      status
      contactName
      contactNumber
    }
  }
`;
export const UPDATE_YARD = gql `
  mutation UpdateYard($data: UpdateYardInput!, $id: String!) {
    updateYard(data: $data, id: $id) {
      nameExternal
      nameInternal
      marketId
      spots
      vendor
      address
      status
      contactName
      contactNumber
    }
  }
`;
export const DELETE_YARD = gql `
  mutation Mutation($id: String!) {
    deleteYard(id: $id)
  }
`;
